import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import styles from "./salesVsCollectionBarChart.module.css";

export const SalesVsCollectionBarChart = ({ dataKey, data }) => {
  return (
    <section style={{ height: 400 }} className="container">
      <h6 className={`${styles.salesCollectionHeader} text-center p-2`}>
        Sales Vs Collection BarChart (€)
      </h6>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={dataKey} />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar
            dataKey="sales"
            fill="#4941edff"
            activeBar={<Rectangle fill="#1b13b2ff" stroke="blue" />}
          />
          <Bar
            dataKey="collection"
            fill="#18b725ff"
            activeBar={<Rectangle fill="#18b725ff" stroke="purple" />}
          />
        </BarChart>
      </ResponsiveContainer>
    </section>
  );
};
